(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const input = root.querySelector('[data-brand-input]');
    const items = [...root.querySelectorAll('[data-brand-item]')];
    const groups = [...root.querySelectorAll('[data-brand-group]')];
    const status = root.querySelector('[data-brand-status]');
    const clear = root.querySelector('[data-brand-clear]');
    const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    function filter() {
      const query = normalize(input.value);
      let count = 0;
      for (const item of items) {
        item.hidden = !normalize(item.dataset.brandName).includes(query);
        if (!item.hidden) count++;
      }
      for (const group of groups) {
        group.hidden = ![...group.querySelectorAll('[data-brand-item]')].some(item => !item.hidden);
        const link = [...root.querySelectorAll('[data-brand-letter]')].find(link => link.dataset.brandLetter === group.dataset.letter);
        link.setAttribute('aria-disabled', String(group.hidden));
        link.tabIndex = group.hidden ? -1 : 0;
      }
      status.textContent = `${count} ${count === 1 ? status.dataset.singleCountLabel || status.dataset.countLabel : status.dataset.countLabel}`;
      clear.hidden = input.value.length === 0;
      root.querySelector('[data-brand-empty]').hidden = count !== 0;
    }
    input.addEventListener('input', filter);
    const reset = () => { input.value = ''; filter(); input.focus(); };
    clear.addEventListener('click', reset);
    input.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); reset(); } });
    root.querySelector('[data-brand-search]').hidden = false;
    filter();
  }
  const mount = () => document.querySelectorAll('[data-rival-brands]').forEach(init);
  mount();
  document.addEventListener('shopify:section:load', mount);
})();
